import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class CommunicationEventReportService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getCommunicationEventsReport(
        // chosenRegions: number[],
        // chosenCounties: number[],
        // chosenSchoolDistricts: number[],
        // chosenSchools: number[],
        // schoolYear: string,
        // communicationTypesIDs: number[],
        // gradeIDs: number[],
        // expiredEligibility: boolean,
        // expiredQAD: boolean,
        // noCommunicationEvent: boolean,
        // rAttending: boolean,
        // rNotAttending: boolean
        payload: any
    ): Observable<any> {
        return this.post<any>(EndPoints.studentCommunicationEvents_GetCommunicationEventsReport, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            communicationTypesIDs: payload.communicationTypesIDs,
            gradeIDs: payload.gradeIDs,
            expiredEligibility: payload.expiredEligibility,
            expiredQAD: payload.expiredQAD,
            noCommunicationEvent: payload.noCommunicationEvent,
            rAttending: payload.rAttending,
            rNotAttending: payload.rNotAttending
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getCommunicationEventPurposeTypes(): Observable<any> {
        return this.get<any>(EndPoints.studentCommunicationEvents_GetCommunicationEventPurposeTypes);
    }
}
